export default __webpack_public_path__ + "static/media/linking.48b3a43d.png";